import { render, staticRenderFns } from "./InactiveInstance.vue?vue&type=template&id=2bc6495a&scoped=true&"
import script from "./InactiveInstance.vue?vue&type=script&lang=js&"
export * from "./InactiveInstance.vue?vue&type=script&lang=js&"
import style0 from "./InactiveInstance.vue?vue&type=style&index=0&id=2bc6495a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc6495a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VRow,VSheet})
